export const SRC_SET = Object.freeze({
	xl: 1920,
	lg: 1280,
	md: 980,
	sm: 640,
})

export const MEDIA_POSITION = Object.freeze({
	ABOVE_QUESTION: 'above_question',
	BELOW_QUESTION: 'below_question',
	LEFT_CONTAINED: 'left_contained',
	LEFT_COVER: 'left_cover',
	RIGHT_CONTAINED: 'right_contained',
	RIGHT_COVER: 'right_cover',
	BACKGROUND: 'background',
	TOP_COVER: 'top_cover',
})
